export const CNB_TYPE = {
    NONE: '',
    A: 'A', // A : 게임 사이트
    B: 'B', // B : 게임 프로모션, 업데이트 연대기 사이트 - 서비스 전체보기, BI, 로그인 / 로그아웃
    C: 'C', // C : 회원 사이트 (마이페이지, 고객센터, N샵)
    D: 'D', // D : 기타 사이트 (메인, 약관/정책, 공지사항, 장기 미이용 복귀 센터, 게임시간선택제)
    PURPLE: 'PURPLE' // PURPLE: 퍼플 웹뷰에서 사용하는 CNB
};

export const NETWORK = {
    opdev: 'opdev',
    sb: 'sb',
    rc: 'rc',
    stage: 'stage',
    live: 'live'
};

export const STATIC_DOMAIN = {
    [NETWORK.opdev]: 'https://op-assets.ncsoft.com',
    [NETWORK.sb]: 'https://assets.sb.plaync.com',
    [NETWORK.rc]: 'https://rc-assets.playnccdn.com',
    [NETWORK.stage]: 'https://stage-assets.plaync.com', // this.__env는 stage -> live로 봄
    [NETWORK.live]: 'https://assets.playnccdn.com',
};

export const PLAYNC_DOMAIN = {
    [NETWORK.opdev]: 'https://www.sb.plaync.com',
    [NETWORK.sb]: 'https://www.sb.plaync.com',
    [NETWORK.rc]: 'https://rc-www.plaync.com',
    [NETWORK.live]: 'https://www.plaync.com'
};

/*
    useGameStart: 'download'일 때, 플랫폼 데이터
    icon은 기본적으로 css에 선언되어 있으며, 다른 icon 필요할 때 icon url을 넣어주면 생성하도록 작업함
*/
export const DOWNLOAD_PLATFORM = {
    googlePlay: {
        platform: 'googlePlay',
        name: 'Google Play',
        url: '',
        icon: '',
        target: '_blank'
    },
    appStore: {
        platform: 'appStore',
        name: 'App store',
        url: '',
        icon: '',
        target: '_blank'
    },
    purple: {
        platform: 'purple',
        name: 'PURPLE',
        url: '',
        icon: '',
        target: '_blank'
    },
    playstation4: {
        platform: 'playstation4',
        name: 'Playstation 4',
        url: '',
        icon: '',
        target: '_blank'
    },
    playstation5: {
        platform: 'playstation5',
        name: 'Playstation 5',
        url: '',
        icon: '',
        target: '_blank'
    },
    xBox: {
        platform: 'xBox',
        name: 'X BOX',
        url: '',
        icon: '',
        target: '_blank'
    },
    steam: {
        platform: 'steam',
        name: 'Steam',
        url: '',
        icon: '',
        target: '_blank'
    },
    epicGames: {
        platform: 'epicGames',
        name: 'Epic games',
        url: '',
        icon: '',
        target: '_blank'
    },
    oneStore: {
        platform: 'oneStore',
        name: 'One store',
        url: '',
        icon: '',
        target: '_blank'
    },
    galaxyStore: {
        platform: 'galaxyStore',
        name: 'Galaxy store',
        url: '',
        icon: '',
        target: '_blank'
    }
};

/*
    Purple Device Type
*/
export const PURPLE_DEVICE = {
    launcher: 'launcher',
    mobile: 'mobile'
};

/*
    Purple MobileApp scheme
*/
export const PURPLE_SCHEME = {
    close: 'nc2://close',
    external: 'nc2://external?url=',
    webview: 'ncmtalk://webview?url='
};